import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {map, flattenDeep} from 'lodash';

class KycLevelDetails extends Component {
  render() {
    const {t, items} = this.props;
    return (
      <div className="py-2 kyc-details-table">
        {!!items && !!items.length &&
          <Table bordered responsive>
            <tbody>
              <tr>
                <td style={{width: 80}} className='text-info text-center'>{t('Documents')}</td>
                <td>
                  <ul className='mt-2'>
                    {map(flattenDeep(items), (item, index) => (
                      <li key={index}>{t(item)}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            </tbody>
          </Table>
        }
      </div>
    );
  }
}

export default withTranslation()(KycLevelDetails);